<script setup lang="ts">
defineProps<{
  icon?: string
}>()

const _icons = ['i-ri:shield-user-fill']
</script>

<template>
  <div class="h7.25 inline-flex of-hidden rd-sm bg-emerald-100/75">
    <div class="h7.25 w7.5 flex flex-row items-center justify-center bg-emerald c-white">
      <Icon :name="icon" />
    </div>
    <span class="flex items-center px2.5 text-sm c-emerald-500 fw600">
      <slot mdc-unwrap="p" />
    </span>
  </div>
</template>
